import { render, staticRenderFns } from "./FiltrarRelatorioDialog.vue?vue&type=template&id=1ec4b871"
import script from "./FiltrarRelatorioDialog.vue?vue&type=script&lang=js"
export * from "./FiltrarRelatorioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports